import { useClient } from "@adamlip/okeoke.client"
import { useParams } from "react-router-dom"
import { scroller } from "react-scroll"
import { useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import LocationCard from "./LocationCard"
import { BasketContext } from "contexts/BasketContext"

export default function Locations() {
  const { setIsUserSelectedLocation } = useContext(BasketContext)
  const { setSelectedLocation, locations } = useClient()
  const { id } = useParams()
  const navigate = useNavigate()

  const navigateToOrder = (locationUUID) => {
    setSelectedLocation(locationUUID)
    setIsUserSelectedLocation(true)
    navigate("/order")
  }

  useEffect(() => { }, [])

  useEffect(() => {
    if (id) {
      const options = {
        duration: 1500,
        delay: 100,
        smooth: true,
        containerId: "locations-container",
        offset: -40,
      }
      setTimeout(() => {
        scroller.scrollTo(id, options)
      }, 100)
    }
    //eslint-disable-next-line
  }, [])

  if (!locations) return null

  //https://cdn.okeoke.io/globalAsset/backgrounds/cafe

  return (
    <div className={`newsFeed-root p-2 h-full flex flex-col`}>
      <div className=""></div>
      <div
        className="flex-grow flex flex-wrap justify-center pb-96 overflow-auto"
        id="locations-container"
      >
        {Object.values(locations)
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .map((location) => (
            <LocationCard
              key={location.uuid}
              location={location}
              navigateToOrder={() => navigateToOrder(location.uuid)}
            />
          ))}
      </div>
    </div>
  )
}
